import { useOrderConfiguration } from "@jasper/use-cases";
import { Loader, Stack } from "@mantine/core";
import { Navigate, useOutletContext } from "react-router-dom";

const DefaultProduct = () => {
  const { orderId } = useOutletContext<{ orderId: string }>();
  const { order, isLoading } = useOrderConfiguration({
    orderId,
  });

  const firstProduct =
    (order?.products ?? []).length > 0 ? order?.products[0] : null;

  if (isLoading) {
    return (
      <Stack h="100%" w="100%" justify="center" align="center">
        <Loader />
      </Stack>
    );
  }

  if (!firstProduct?.id) {
    return (
      <Navigate to={`/orders/${orderId}/configure/products/add`} replace />
    );
  }

  return (
    <Navigate
      to={`/orders/${orderId}/configure/products/${firstProduct.id}/`}
      replace
    />
  );
};

export default DefaultProduct;
